export class LookupTypesConstants {
  public static DEFAULT: string = 'DEFAULT';
  public static INNER_MODE: string = 'INNER_MODE';
  public static MODAL: string = 'MODAL';
}
